import React from 'react'
import PersonIcon from '@mui/icons-material/Person';
import { Box, Typography } from '@mui/material';
import useStyles from '../KaraokeStyles';

const SOLO_INSTRUCTIONS = [
    { color: '#3f51b5', label: 'person one' },
    { color: '#4caf50', label: 'person two' },
    { color: '#de7e09', label: 'both players' },
];

const GROUP_INSTRUCTIONS = [
    { color: '#3f51b5', label: 'person 1' },
    { color: '#4caf50', label: 'person 2' },
    { color: '#9c27b0', label: 'person 3' },
    { color: '#009688', label: 'person 4' },
    { color: '#de7e09', label: 'all persons' },
];

const LyicsSelectionInstructions = ({ isGroupMode = false }) => {
    const classes = useStyles();
    const instructions = isGroupMode ? GROUP_INSTRUCTIONS : SOLO_INSTRUCTIONS;

    return (
        <Box textAlign="center" mb={1}>
            <Typography className={classes.commandsTitle} gutterBottom>
                Select lyrics for {isGroupMode ? 'group members' : 'players'}
            </Typography>
            <Typography className={classes.instructions} >
                Tap a line to select it (tap again to deselect), drag across multiple lines, or Shift+click to select a range. Then assign the selection using the buttons below.
                <PersonIcon fontSize="12px" style={{ margin: '0 5px', color: 'lightGray', verticalAlign: 'middle' }} />
            </Typography>
            <Typography className={classes.instructions} >
                Bulk tools: “Select All” / “Select Unassigned” grab lines in one click, and “Alternate” distributes the selection across persons in order{isGroupMode
                    ? " (person 1 → 4 → 2 → 3, repeating)."
                    : " (line 1 → person 1, line 2 → person 2, …)."}
            </Typography>
            <Typography className={classes.instructions} >
                Fix a mistake without re-syncing: use a line’s pencil icon (or double-click the text) to adjust its characters, or the trash icon to delete the line — its timing and solo/group assignments shift up automatically.
            </Typography>

            {instructions.map(({ color, label }) => (
                <Typography key={label} className={classes.instructions} >
                    Lyrics selected for
                    <PersonIcon fontSize="12px" style={{ color, marginLeft: 5, verticalAlign: 'middle' }} />
                    <span style={{ color, fontWeight: 'medium' }}>{label}</span> will be highlighted in <span style={{ color, fontWeight: 500 }}>{label.includes('both') || label.includes('all') ? 'orange' : color === '#3f51b5' ? 'blue' : color === '#4caf50' ? 'green' : color === '#9c27b0' ? 'purple' : 'teal'}</span>
                </Typography>
            ))}
        </Box>
    )
}

export default LyicsSelectionInstructions
